import ApplicationController from './application_controller';

export default class extends ApplicationController {
  checkRequiredFilesAndSubmit(event) {
    let filePresence = null;
    const fileFieldName = 'documents[]';

    const files = document.getElementsByName(fileFieldName);

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < files.length; index++) {
      const inputField = files[index];
      const fieldValue = inputField.value;

      if (fieldValue && fieldValue !== "") {
        filePresence = fieldValue;
      }
    }

    if (!filePresence) {
      alert('Please attach at least one intake PDF document');
      event.preventDefault();
    }
  }
}
